const EscapeInput = () => null;

export default EscapeInput;
